import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import MainLayout from "../../components/layout/MainLayout";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import ClientFeedbackForm from "./ClientFeedbackForm";
import { createClientFeedback } from "../../store/slices/clientFeedbackSlice";
import { fetchPatient } from "../../store/slices/patientsSlice";

const AddClientFeedback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { caseId, patientId } = state || {};

  const [formData, setFormData] = useState({ patient_id: patientId || "", case_id: caseId || "" });
  const [patientData, setPatientData] = useState(null);

  useEffect(() => {
    if (patientId) {
      dispatch(fetchPatient(patientId)).unwrap().then((p) => setPatientData(p)).catch((err) => console.error("Failed to fetch patient details:", err));
    }
  }, [dispatch, patientId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await dispatch(createClientFeedback(formData)).unwrap();
      Swal.fire({ title: "Success!", text: "Client Feedback added successfully.", icon: "success", timer: 2000, showConfirmButton: false });
      navigate(`/phase04/client-feedback/edit/${res.id}`, { state: { patientId: patientId || res.patient_id, caseId: caseId || res.case_id } });
    } catch (err) {
      let msg = "Failed to add Client Feedback";
      if (typeof err === "string") msg = err;
      else if (typeof err === "object" && err !== null) msg = Object.values(err).flat().join("\n");
      Swal.fire({ title: "Error", text: msg, icon: "error" });
    }
  };

  return (
    <MainLayout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Breadcrumbs />
        {patientData && (
          <div className="card mb-4">
            <div className="card-body bg-light-primary rounded-4">
              <div className="row g-3">
                <div className="col-md-3"><span className="fw-semibold text-secondary small d-block">Client Name:</span><span className="fw-bold text-dark">{patientData.first_name} {patientData.last_name}</span></div>
                <div className="col-md-3"><span className="fw-semibold text-secondary small d-block">MR Number:</span><span className="fw-bold text-dark">{patientData.mr_no || "N/A"}</span></div>
                <div className="col-md-3"><span className="fw-semibold text-secondary small d-block">Date of Birth:</span><span className="fw-bold text-dark">{patientData.dob ? new Date(patientData.dob).toLocaleDateString("en-GB") : "N/A"}</span></div>
                <div className="col-md-3"><span className="fw-semibold text-secondary small d-block">Gender:</span><span className="fw-bold text-dark capitalize">{patientData.gender || "N/A"}</span></div>
              </div>
            </div>
          </div>
        )}
        <div className="card">
          <div className="card-header border-bottom"><h5 className="mb-0">Add Client Feedback</h5><small className="text-muted">Client Satisfaction Report</small></div>
          <form onSubmit={handleSubmit}>
            <ClientFeedbackForm formData={formData} setFormData={setFormData} />
            <div className="row px-4 pb-4">
              <div className="col-md-2 ms-auto">
                <button type="submit" className="btn btn-primary w-100"><i className="ri-save-3-line me-1"></i> Save</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddClientFeedback;
